import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { SlideadjustmentunitpriceLstInfoDto } from 'sg-api';
import { ActivatedRoute } from '@angular/router';
import { DisplayMode } from 'cbc-shared-lib';

/**
 * スライド調整単価検索画面(検索結果)
 * @exports
 * @class Sgkc031dSlideTankaSearchResultComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc031d-slide-tanka-search-result',
    templateUrl: './sgkc031d-slide-tanka-search-result.component.html',
    styleUrl: './sgkc031d-slide-tanka-search-result.component.scss',
})
export class Sgkc031dSlideTankaSearchResultComponent implements OnInit, OnDestroy {
    /** 
    * コンストラクタ
    * @param {ActivatedRoute} route
    * @memberof Sgkc031dSlideTankaSearchResultComponent
    */
    constructor(
        private route: ActivatedRoute,
    ) {
    }
    /** 行ダブルクリック時のイベント */
    @Output() onDbClickRowEvent = new EventEmitter<SlideadjustmentunitpriceLstInfoDto>();
    /** 追加ボタン押下時のイベント */
    @Output() onClickAddEvent = new EventEmitter<void>();
    /** スライド調整単価一覧表出力ボタン押下時のイベント */
    @Output() onClickSlideTankaOutputEvent = new EventEmitter<void>();
    /** 調整単位料金一覧表出力ボタン押下時のイベント */
    @Output() onClickAdjustTankaOutputEvent = new EventEmitter<void>();
    /** セレクトボックス変更時のイベント */
    @Output() onSelectedEvent = new EventEmitter<SlideadjustmentunitpriceLstInfoDto[]>();
    /** 親コンポーネントから値の受け取り */
    @Input() slideTankatable: SlideadjustmentunitpriceLstInfoDto[];
    /** 画面表示モード */
    @Input() mode: string;
    /** テーブルのソート機能 */
    @ViewChild('sort', { static: true }) sort: MatSort;
    /** テーブルのページング機能 */
    @ViewChild('paginator', { static: true }) paginator: MatPaginator;


    /** チェックボックスの活性制御フラグ */
    isCheckboxDisabled: boolean = true;
    /** 追加ボタン表示制御フラグ */
    isAddButtonVisible: boolean = false;
    /** 追加ボタン活性制御フラグ */
    isAddButtonDisabled: boolean = true;
    /** スライド調整単価一覧表出力ボタン表示制御フラグ */
    isSlideButtonVisible: boolean = false;
    /** スライド調整単価一覧表出力ボタン活性制御フラグ */
    isSlideButtonDisabled: boolean = true;
    /** 調整単位料金一覧表出力ボタン表示制御フラグ */
    isAdjustButtonVisible: boolean = false;
    /** 調整単位料金一覧表出力ボタン活性制御フラグ */
    isAdjustButtonDisabled: boolean = true;
    /** htmlテーブル選択情報 */
    selectionSearchResultDisplay: SelectionModel<SlideadjustmentunitpriceLstInfoDto> = new SelectionModel<SlideadjustmentunitpriceLstInfoDto>(true, []);
    /** htmlテーブルデータ */
    dataSourceSearchResultDisplay = new MatTableDataSource<SlideadjustmentunitpriceLstInfoDto>();
    /** 検索結果表示リスト */
    displayedColumnsCol: string[] = [
        'select',
        'slideadjustmentunitpriceAname',
        'applyYm',
        'slideadjustmentunitprice',
        'oldnewdivision',
        'slideadjustmentunitpriceExplanation',
        'apprvStsAname',
    ];

    /** 
     * 初期処理
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    ngOnInit(): void {
       
        // 画面モードが登録または参照時、チェックボックス、スライド調整単価一覧表出力ボタン、調整単位料金一覧表出力ボタンを表示
        if (this.mode=== DisplayMode.create || this.mode=== DisplayMode.read) {
            this.isCheckboxDisabled = false;
            this.isSlideButtonVisible = true;
            this.isAdjustButtonVisible = true;
        }
        // 画面モードが登録時追加ボタンを表示
        if (this.mode=== DisplayMode.create) {
            this.isAddButtonVisible = true;
        }
        this.dataSourceSearchResultDisplay.data = this.slideTankatable;
    }

    /** 
     * ビュー初期化後に呼び出されるライフサイクルフック。
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    ngAfterViewInit() {
        this.dataSourceSearchResultDisplay.paginator = this.paginator;
        this.dataSourceSearchResultDisplay.sort = this.sort;
    }

    /** 
     * コンポーネントが破棄される前に呼び出されるライフサイクルフック。
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    ngOnDestroy(): void {
    }

    /** 
     * 選択した要素の数が行の合計数と一致するかどうかを判定する。
     * @param {SelectionModel<SlideadjustmentunitpriceLstInfoDto>} selection
     * @param {MatTableDataSource<SlideadjustmentunitpriceLstInfoDto>} dataSourceSearchResultDisplay
     * @returns {boolean}
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    isAllSelected(selection: SelectionModel<SlideadjustmentunitpriceLstInfoDto>, dataSourceSearchResultDisplay: MatTableDataSource<SlideadjustmentunitpriceLstInfoDto>) {
        const numSelected = selection.selected.length;
        const numRows = dataSourceSearchResultDisplay.data.length;
        return numSelected === numRows;
    }

    /** 
     * すべての行が選択されていない場合は、すべての行を選択する。それ以外の場合は、選択をクリアする。
     * @param {SelectionModel<SlideadjustmentunitpriceLstInfoDto>} selection
     * @param {MatTableDataSource<SlideadjustmentunitpriceLstInfoDto>} dataSourceSearchResultDisplay
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    masterToggle(selection: SelectionModel<SlideadjustmentunitpriceLstInfoDto>, dataSourceSearchResultDisplay: MatTableDataSource<SlideadjustmentunitpriceLstInfoDto>) {
        this.isAllSelected(selection, dataSourceSearchResultDisplay) ?
            selection.clear() :
            dataSourceSearchResultDisplay.data.forEach(row => selection.select(row));
    }

    /** 
     * チェックボックス選択時の処理
     * @param {*} event
     * @param {SelectionModel<SlideadjustmentunitpriceLstInfoDto>} selection
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    onChangeSelection(event: any, selection: SelectionModel<SlideadjustmentunitpriceLstInfoDto>): void {
        if (event) {

            this.onSelectedEvent.emit(selection.selected);
            
            // 選択されている件数を取得
            const selectedCount = selection.selected.length;
            // 1件以上選択されている場合にスライド調整単価一覧表出力ボタン、調整単位料金一覧表出力ボタンを活性化
            this.isSlideButtonDisabled = selectedCount === 0;
            this.isAdjustButtonDisabled = selectedCount === 0;
            // 1件のみ選択されている場合に追加ボタンを活性化
            this.isAddButtonDisabled = selectedCount !== 1;
        }
    }

    /** 
     * 行ダブルクリック時の処理
     * @param {SlideadjustmentunitpriceLstInfoDto} row
     * @param {*} event
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    onDbClickRow(row: SlideadjustmentunitpriceLstInfoDto, event: any): void {
        const target = event.target as HTMLElement;
        if (target.closest('mat-checkbox')) {
            return;
        }
        this.onDbClickRowEvent.emit(row);
    }

    /** 
     * スライド調整単価一覧表出力ボタン押下時の処理
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    onClickSlideOutput(): void {
        this.onClickSlideTankaOutputEvent.emit();
    }

    /** 
     * 調整単位料金一覧表出力ボタン押下時の処理
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    onClickAdjustOutput(): void {
        this.onClickAdjustTankaOutputEvent.emit();
    }

    /** 
     * 追加ボタン押下時の処理
     * @memberof Sgkc031dSlideTankaSearchResultComponent
     */
    onClickTankaAdd(): void {
        this.onClickAddEvent.emit();
    }
}
